import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DOW_DEMO_DNA1_3 = {
  title: `The dashboard lets her see the entire \npipeline and highlights areas of failure \nthrough <span style="color: #92D1FF;"> Operation Lineage features.</span>`,
  subtitle: "Data Operations Workbench demo",
  label: [
    { iconPath: "start.png", text: "Monitoring" },
    { iconPath: "start.png", text: "Operation Lineage" },
  ],
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(108),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(106),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "DNA1/DNA1_DOW_DEMO_03_Computer.png",
          imageStyle: {
            position: "absolute",
            right: "116.38px",
            bottom: "226.24px",
          },
          effect: "animate-opacity",
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_03_PopUp_1.png",
          imageStyle: { position: "absolute", right: "285px", bottom: "508px" },
        },
        {
          image: "DNA1/DNA1_DOW_DEMO_03_PopUp_2.png",
          imageStyle: {
            position: "absolute",
            right: "200px",
            bottom: "119.92px",
          },
        },
      ]}
      pageNumber={107}
    />
  ),
};
